<div class="close-icon">
    <i><span style="font-size: 40px; font-weight: 600;" (click)="onCancel()"
            class="material-icons close">close</span></i>
</div>
<iframe [src]="generateSafeImageUrl()" frameborder="0" allowfullscreen></iframe>